const minValue = 30
const maxValue = 49

interface OcularK {
    axis: number
    k: number
}

interface OcularKSet {
    k1: OcularK
    k2: OcularK
    incision: number
    /** Astigmatismo induzido pela cirurgia (SIA), em D. Combinado com
     * `incision` (eixo), corrige o astigmatismo corneano medido para o
     * previsto no pós-operatório antes do cálculo torico. 0 = não informado. */
    sia: number
}

export { 
    minValue, 
    maxValue, 
    type OcularK,
    type OcularKSet,
}